// test898
(898 && 0);
